/**
 * 发票管理 API
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	// 获取发票列表
	getInvoices() {
		return Ajax.get("/invoices")
	},
	// 获取单个发票
	getInvoice(id) {
		return Ajax.get(`/invoices/${id}`)
	},
	// 获取统计
	getInvoiceStatistics() {
		return Ajax.get("/invoices/statistics")
	},
	// 创建发票
	createInvoice(params = {}) {
		return Ajax.post("/invoices", params)
	},
	// 更新发票
	updateInvoice(id, params = {}) {
		return Ajax.put(`/invoices/${id}`, params)
	},
	// 删除发票
	deleteInvoice(id) {
		return Ajax.delete(`/invoices/${id}`)
	},
	// 作废发票
	voidInvoice(id) {
		return Ajax.post(`/invoices/${id}/void`)
	}
}
